import { H2, IconButton, Card, CardBody, LogoVertical } from "@datapay-by-datacom/design-system";
import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Layout } from "../../layout";
import { getBrandName, getLogoUrl } from "../../brand-config";
import { useAllFeatureFlags } from "../../feature-flags";
import type { FeatureFlagConfig } from "../../feature-flags";
import { announcements } from "../data/announcements";
import s from "./AnnouncementsScreen.module.css";

function isFeatureFlagEnabled(
  flags: Record<string, unknown>,
  config?: FeatureFlagConfig,
): boolean {
  if (!config) return true;
  const value = flags[config.flag];
  return typeof value === "boolean" ? value : config.default;
}

export function AnnouncementsScreen() {
  const navigate = useNavigate();
  const flags = useAllFeatureFlags();
  const logoUrl = getLogoUrl();

  const visibleAnnouncements = announcements.filter((a) =>
    isFeatureFlagEnabled(flags, a.featureFlag),
  );

  return (
    <Layout>
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.headerContent}>
            <IconButton onPress={() => navigate(-1)} aria-label="Go back">
              <IoChevronBack size={20} />
            </IconButton>
            <H2>Release Announcements</H2>
          </div>
        </div>

        <div className={s.content}>
          {visibleAnnouncements.length > 0 ? (
            visibleAnnouncements.map((announcement) => (
              <Card key={announcement.id}>
                <CardBody>
                  <div className={s.announcement}>
                    <div className={s.branding}>
                      <div className={s.logo}>
                        {logoUrl ? (
                          <img src={logoUrl} alt={getBrandName()} className={s.logoImg} />
                        ) : (
                          <LogoVertical />
                        )}
                      </div>
                      <div className={s.brandText}>
                        <span className={s.brandTitle}>Payroll Assistant</span>
                        <span className={s.brandSubtitle}>
                          Powered by {getBrandName()}
                        </span>
                      </div>
                    </div>

                    <span className={s.date}>
                      {new Date(announcement.releaseDate + "T00:00:00").toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })}
                    </span>
                    <h3 className={s.title}>{announcement.title}</h3>
                    <div className={s.body}>
                      <ReactMarkdown
                        remarkPlugins={[remarkGfm]}
                        components={{
                          a: ({ children, href, ...props }) => {
                            if (href && href.startsWith("/")) {
                              return <Link to={href}>{children}</Link>;
                            }
                            return (
                              <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
                                {children}
                              </a>
                            );
                          },
                        }}
                      >
                        {announcement.body}
                      </ReactMarkdown>
                    </div>
                  </div>
                </CardBody>
              </Card>
            ))
          ) : (
            <Card>
              <CardBody>
                <p className={s.empty}>No current announcements.</p>
              </CardBody>
            </Card>
          )}
        </div>
      </div>
    </Layout>
  );
}
